import React, { useState } from 'react';
import './assets/styles/index.scss';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import LandingPage from './pages/LandingPage/LandingPage';
import ConnectWalletPage from './pages/ConnectWalletPage/ConnectWalletPage';
import UserDashboardPage from './pages/UserDashboardPage/UserDashboardPage';
import { AuthenticatedRoutesWrapper, DappProvider } from '@multiversx/sdk-dapp/wrappers';
import { environment, projectId } from './config';
import { SignTransactionsModals, TransactionsToastList } from '@multiversx/sdk-dapp/UI';

function App() {
    const [forceReload, setForceReload] = useState(null);

    const routes = [
        {
            path: '/',
            element: <LandingPage />,
            authenticatedRoute: false,
        },
        {
            path: '/connect-wallet',
            element: <ConnectWalletPage />,
            authenticatedRoute: false,
        },
        {
            path: '/dashboard',
            element: <UserDashboardPage key={forceReload} />,
            authenticatedRoute: true,
        },
    ];

    return (
        <DappProvider
            environment={environment}
            customNetworkConfig={{ walletConnectV2ProjectId: projectId }}
            dappConfig={{
                shouldUseWebViewProvider: true,
            }}
            customComponents={{
                transactionTracker: {
                    props: {
                        onSuccess: (sessionId) => {
                            setForceReload(sessionId);
                        },
                    },
                },
            }}
        >
            <Router>
                <SignTransactionsModals />
                <TransactionsToastList successfulToastLifetime={2500} />
                <Navbar />
                <AuthenticatedRoutesWrapper routes={routes} unlockRoute="/connect-wallet">
                    <Routes>
                        {routes.map((route, index) => (
                            <Route key={index} path={route.path} element={route.element} />
                        ))}
                    </Routes>
                </AuthenticatedRoutesWrapper>
            </Router>
        </DappProvider>
    );
}

export default App;
